import { Phone, Mail, Facebook, Instagram, ArrowUpRight } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative px-6 lg:px-10 py-24 lg:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#0055FF]" />
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#0055FF]">
            Get In Touch
          </span>
        </div>

        <h2
          data-testid="contact-heading"
          className="font-heading font-extrabold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-4xl"
        >
          Ready To Lift With Us?
          <br />
          <span className="text-white/50">Reach out.</span>
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {/* Phone card */}
          <a
            href="tel:6185500625"
            data-testid="contact-phone-card"
            className="group relative border border-white/10 bg-[#0F0F11] p-8 hover:border-[#0055FF] hover:bg-[#0055FF] transition-colors"
          >
            <Phone className="text-[#0055FF] group-hover:text-white transition-colors" size={32} />
            <div className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-white/50 group-hover:text-white/90">
              Call Us
            </div>
            <div className="mt-2 font-heading font-black text-2xl lg:text-3xl text-white tracking-tight">
              (618) 550-0625
            </div>
            <ArrowUpRight
              className="absolute top-6 right-6 text-white/30 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
              size={22}
            />
          </a>

          {/* Email card */}
          <a
            href="mailto:jfbarbell@gmail.com?subject=Membership%20Inquiry"
            data-testid="contact-email-card"
            className="group relative border border-white/10 bg-[#0F0F11] p-8 hover:border-[#0055FF] hover:bg-[#0055FF] transition-colors"
          >
            <Mail className="text-[#0055FF] group-hover:text-white transition-colors" size={32} />
            <div className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-white/50 group-hover:text-white/90">
              Email Us
            </div>
            <div className="mt-2 font-heading font-black text-xl lg:text-2xl text-white tracking-tight break-all">
              jfbarbell@gmail.com
            </div>
            <ArrowUpRight
              className="absolute top-6 right-6 text-white/30 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
              size={22}
            />
          </a>

          {/* Facebook card */}
          <a
            href="https://www.facebook.com/JerseyFitBarbell"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-facebook-card"
            className="group relative border border-white/10 bg-[#0F0F11] p-8 hover:border-[#0055FF] hover:bg-[#0055FF] transition-colors"
          >
            <Facebook className="text-[#0055FF] group-hover:text-white transition-colors" size={32} />
            <div className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-white/50 group-hover:text-white/90">
              Follow Along
            </div>
            <div className="mt-2 font-heading font-black text-xl lg:text-2xl text-white tracking-tight">
              @JerseyFitBarbell
            </div>
            <ArrowUpRight
              className="absolute top-6 right-6 text-white/30 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
              size={22}
            />
          </a>

          {/* Instagram card */}
          <a
            href="https://www.instagram.com/jerseyfit_barbell/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-instagram-card"
            className="group relative border border-white/10 bg-[#0F0F11] p-8 hover:border-[#0055FF] hover:bg-[#0055FF] transition-colors"
          >
            <Instagram className="text-[#0055FF] group-hover:text-white transition-colors" size={32} />
            <div className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-white/50 group-hover:text-white/90">
              Follow Along
            </div>
            <div className="mt-2 font-heading font-black text-xl lg:text-2xl text-white tracking-tight">
              @jerseyfit_barbell
            </div>
            <ArrowUpRight
              className="absolute top-6 right-6 text-white/30 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
              size={22}
            />
          </a>
        </div>

        {/* Final CTA banner */}
        <div
          data-testid="contact-final-cta"
          className="mt-14 relative border border-white/10 bg-gradient-to-br from-[#0F0F11] to-[#0055FF]/20 p-10 lg:p-14 overflow-hidden"
        >
          <div className="absolute -right-20 -bottom-20 w-80 h-80 rounded-full bg-[#0055FF]/30 blur-[100px]" />
          <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div>
              <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#0055FF] mb-3">
                Call or Email to join · No online signup
              </div>
              <h3 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight text-white leading-[0.95]">
                Your First Rep
                <br />
                Starts With A Call.
              </h3>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:6185500625"
                data-testid="contact-final-call-btn"
                className="btn-primary px-7 py-4 font-heading font-bold uppercase tracking-wider text-sm inline-flex items-center justify-center gap-3"
              >
                <Phone size={18} />
                (618) 550-0625
              </a>
              <a
                href="mailto:jfbarbell@gmail.com?subject=Membership%20Inquiry"
                data-testid="contact-final-email-btn"
                className="btn-secondary px-7 py-4 font-heading font-bold uppercase tracking-wider text-sm inline-flex items-center justify-center gap-3"
              >
                <Mail size={18} />
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
